import React from 'react'
import useCards from '../../../hooks/useCards'

const VidaCards = () => {
  const { homeinCards } = useCards()
  
  return (
      <>
          {homeinCards(13)}
      </>
  )
} 

export default VidaCards